import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
const VUE_APP_API_URL_STUDYOO = process.env.VUE_APP_API_URL_STUDYOO;

export default {
  crearAlumno(alumnoData) {
    return axios.post(`${API_URL}/Alumnos/v1/save`, alumnoData);
  },


  buscarAlumnosPorCurso(id_colegio, id_cursos) {
    return axios.post(`${VUE_APP_API_URL_STUDYOO}alumnosPorCurso`,{"IdColegio": id_colegio, "IdCursos": id_cursos});
  }

}